/** @jsxImportSource @emotion/react */
import { default as DesktopButton } from '../Button';
import { selectTotalsCalculated, selectWholeState, selectIsEditing } from 'cart-ui-react/src/autoshipState/selectors';
import { setTotals, setError } from 'cart-ui-react/src/autoshipState/autoshipSlice';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import getAppState from 'app-state';
import Button from '@mui/material/Button';
import t from '@rcm/i18n-client';

interface Props {
  loading?: boolean;
  setLoading: any;
  mobile?: boolean;
}

const CalculateOrderButton = ({ loading, setLoading, mobile = false }: Props) => {
  const data: any = useSelector(selectWholeState);
  const siteId = getAppState('site.siteId');
  const dispatch = useDispatch();
  const isEditing = useSelector(selectIsEditing);
  const totalsCalculated = useSelector(selectTotalsCalculated);
  const canClick = !isEditing && !totalsCalculated && !loading;

  const calculateOrder = () => {
    setLoading(true);
    const buildItems = () => {
      const items = data.items;
      const newItems = [];

      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < items.length; i++) {
        const object = {
          data: null,
          qty: String(items[i].quantity),
          skuNumber: items[i].itemCode,
          type: '',
        };
        newItems.push(object);
      }
      return newItems;
    };

    const body = {
      discountPercent: 40,
      id: -1,
      items: buildItems(),
      shipping: {
        data: {
          autoShipIsMonthly: true,
          isAutoShip: true,
          shipAddress: {
            ...data.shippingAddress,
            isCommercial: null,
            nameLine: '',
            phone: '',
            type: 'BasicShipAddress',
            verified: false,
          },
        },
        type: 'ShippingVistaBasic',
      },
      siteId: siteId,
      user: {
        data: [],
        type: 'GenericDistributor',
      },
    };

    axios
      .post('/api/cart/calculate', body)
      .then(function (response) {
        const apiTotals = response.data.data;
        const newTotals = {
          ...data.totals,
          bvTotal: apiTotals.bvSubTotal ?? 0,
          pvTotal: apiTotals.pvSubTotal ?? 0,
          subtotal: String(apiTotals.subTotal.toFixed(2)),
          discounts: String(apiTotals.discount.toFixed(2)),
          tax: String(apiTotals.tax.toFixed(2)),
          shipping: String(apiTotals.shipping.toFixed(2)),
          total: String(apiTotals.total.toFixed(2)),
        };
        dispatch(setTotals(newTotals));
        setLoading(false);
      })
      .catch(function (error: any) {
        // build error message
        let errMsg = '';
        const message = error.response.data.messages;

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < message.length; i++) {
          errMsg += message[i].value + ', ';
        }
        errMsg = errMsg.substring(0, errMsg.length - 2) + '.';
        dispatch(setError(errMsg ?? 'Unable to calculate totals. Please try again.'));
        setLoading(false);
      });
  };

  return (
    <div css={{ alignSelf: 'center' }}>
      {data.shippingAddress.country == 'USA' ? (
        mobile ? (
          <Button
            disabled={!canClick}
            variant="contained"
            color="tertiary"
            size="small"
            sx={{ color: 'white', fontWeight: 'bold', fontSize: '12px' }}
            onClick={calculateOrder}
          >
            {t('Calculate')}
          </Button>
        ) : (
          <DesktopButton sx={{ width: '100%' }} disabled={!canClick} onClick={calculateOrder}>
            {t('Calculate')}
          </DesktopButton>
        )
      ) : (
        <p>{data.totalsCalculated ? '' : t('Save to recalculate totals.')}</p>
      )}
    </div>
  );
};

export default CalculateOrderButton;
